import { Filter } from "./filter";

type RetrieveProjectsFilter = Filter & {
  includeAllProjects?: boolean;
};

const retrieveProjectsFilter: RetrieveProjectsFilter = {};

export type { RetrieveProjectsFilter };

export { retrieveProjectsFilter };
